import Calendar from '../store/schema/Calendar';
import CalendarEntryExtended from '../store/schema/CalendarEntryExtended';
import CalendarEntry from 'owa-service/lib/contract/CalendarEntry';
import CalendarFolder from 'owa-service/lib/contract/CalendarFolder';
import CalendarId from '../store/schema/CalendarId';
import getCalculatedFolderId from '../utils/getCalculatedFolderId';
import getStore from '../store/store';
import CalendarGroupExtended from '../store/schema/CalendarGroupExtended';
import { getUserMailboxInfo } from 'owa-client-ids';
import { logUsage } from 'owa-analytics-actions';

export function getDefaultCalendar(mailboxId?: string): Calendar {
    if (!mailboxId) {
        // get default account's mailboxId
        mailboxId = getUserMailboxInfo().mailboxId;
    }
    return getStore().defaultCalendars.get(mailboxId);
}

export function getCalendarEntry(calendar: Calendar): CalendarEntry {
    return getCalendarEntryByCalendarId(calendar.id.id);
}

export function getCalendarEntryByCalendarId(calendarId: string): CalendarEntry {
    const { calendarEntryMapping } = getStore();
    const calendarEntry = calendarEntryMapping.get(calendarId);
    if (!calendarEntry) {
        logUsage('CalendarEntryMappingNotFound');
    }
    return calendarEntry;
}

export function getCalendarEntries(): CalendarEntryExtended[] {
    const { calendarEntryMapping } = getStore();
    return [...calendarEntryMapping.values()];
}

export function getCalendarGroups(): CalendarGroupExtended[] {
    const { calendarGroupsMapping } = getStore();
    return [...calendarGroupsMapping.values()];
}

export function getCalendarIdByFolderId(folderId: string): CalendarId {
    const { folderIdToCalendarId } = getStore();
    const calendarId = folderIdToCalendarId.get(folderId);
    if (!calendarId) {
        logUsage('FolderIdToCalendarIdMappingNotFound');
    }

    return calendarId;
}

export function getChangeKeyByCalendarItemId(calendarItemId: string) {
    const { calendarItemIdToChangeKey } = getStore();
    return calendarItemIdToChangeKey.get(calendarItemId);
}

export function getCalendarFolderId(calendar: Calendar): string {
    return getFolderIdByCalendarID(calendar.id.id);
}

export function getFolderIdByCalendarID(calendarId: string): string {
    const { calendarFolderMapping } = getStore();
    const calendarFolder = calendarFolderMapping.get(calendarId);
    if (calendarFolder && (calendarFolder.FolderId || calendarFolder.DistinguishedFolderId)) {
        return calendarFolder.FolderId
            ? calendarFolder.FolderId.Id
            : calendarFolder.DistinguishedFolderId;
    } else {
        return getCalculatedFolderIdByCalendarID(calendarId);
    }
}

export function getCalculatedFolderIdByCalendarID(calendarId: string): string {
    const { calendarEntryMapping } = getStore();

    const calendarEntry = calendarEntryMapping.get(calendarId);
    if (calendarEntry) {
        const folderId = getCalculatedFolderId(calendarEntry);
        return folderId ? folderId.Id : null;
    }
    return null;
}

export function getCalendarFolder(calendar: Calendar): CalendarFolder {
    const { calendarFolderMapping } = getStore();
    return calendarFolderMapping.get(calendar.id.id);
}
